import clsx from 'clsx';
import { compareAsc } from 'date-fns';

import { CreateEventTimetable } from '@event/types';
import Popup from '@popup/components/Popup';
import usePopupStore from '@popup/stores/usePopupStore';
import PopupWrapper from '@ui/components/PopupWrapper';
import { formatCsEventSummary } from '@utils/formatCs';

interface EventTimeSlotsModalProps {
  type: 'tooltip' | 'modal';
  timetables: CreateEventTimetable[];
}

const EventTimeSlotsModal = ({
  timetables,
  type,
}: EventTimeSlotsModalProps) => {
  const {
    popupState: { isEventTimeSlotsModalOpen },
    setPopupState,
  } = usePopupStore();

  return (
    <div
      className={clsx(
        'fixed inset-x-2 bottom-2 z-10 flex items-center justify-center',
        type === 'tooltip' &&
          'invisible absolute inset-x-0 bottom-[calc(100%+20px)] left-1/2 mx-2 -ml-1 w-auto min-w-min max-w-md -translate-x-1/2 opacity-0 group-hover/tooltip:visible group-hover/tooltip:opacity-100',
        isEventTimeSlotsModalOpen && type === 'modal'
          ? 'visible opacity-100'
          : 'invisible opacity-0',
      )}
    >
      <Popup type="tooltip">
        <PopupWrapper
          handleClick={() =>
            setPopupState({ isEventTimeSlotsModalOpen: false })
          }
          isMaxHeightLimit={true}
        >
          {timetables
            .sort((a, b) =>
              compareAsc(new Date(a.timeSlotStart), new Date(b.timeSlotStart)),
            )
            .map((timetable) => (
              <span
                key={timetable.uuid}
                className="mt-2 w-full whitespace-nowrap rounded-[32px] px-6 py-2 font-montserrat font-medium text-brand-gray-100 first-of-type:mt-0"
              >
                {formatCsEventSummary(timetable.timeSlotStart)}
              </span>
            ))}
        </PopupWrapper>
      </Popup>
    </div>
  );
};

export default EventTimeSlotsModal;
